import update from 'immutability-helper';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import { SelfServeBuilderPopupTypes } from 'Popups';
import SelfServeBuilderToolboxConstants from './SelfServeBuilderToolboxConstants';

const initialState = {
  activeToolboxItem: SelfServeBuilderPopupTypes.TEXTBOX,
  displayTooltips: true,
};

const SelfServeBuilderToolboxReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS: {
      const fields = action.data.custom_template.field_outline.fields;
      const activePopup = action.data.custom_template.field_outline.activePopup;
      let activeToolboxItem = SelfServeBuilderPopupTypes.TEXTBOX;
      if (activePopup) {
        activeToolboxItem = fields[activePopup].type;
      }
      activeToolboxItem = action.activeToolboxItem || activeToolboxItem;
      return update(state, {
        activeToolboxItem: { $set: activeToolboxItem },
      });
    }
    case SelfServeBuilderToolboxConstants.TOOLTIPS_HIDE:
      return update(state, {
        displayTooltips: { $set: false },
      });
    case SelfServeBuilderToolboxConstants.ACTIVE_TOOLBOX_ITEM_SET:
      return update(state, {
        activeToolboxItem: { $set: action.toolType },
      });
    default:
      return state;
  }
};

export default SelfServeBuilderToolboxReducer;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/SelfServeBuilderToolboxReducer.jsx